import { render } from "./RightGroupsManager.vue?vue&type=template&id=20307632&scoped=true"
import script from "./RightGroupsManager.vue?vue&type=script&lang=js"
export * from "./RightGroupsManager.vue?vue&type=script&lang=js"

import "./RightGroupsManager.vue?vue&type=style&index=0&id=20307632&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20307632"]])

export default __exports__